module.exports = __webpack_public_path__ + "img/serpentipity.a549a686.png";